import { observable, action, makeAutoObservable } from 'mobx';
import Setting from '../models/Setting';

class SettingStore {
    constructor() {
        makeAutoObservable(this)
    }

    @observable settings: Setting = {
        socketAddress: 'http://localhost:1337',
        apiEndPoints: {},
        banner: null,
        description: "",
        sertificate_types: [],
        payment_url: ""
    };

    @action updateSettings(data: Setting) {
        this.settings = data;
    }
}

export default new SettingStore();